module.exports = __webpack_public_path__ + "static/media/2-sits_soffor.4fb03709.jpg";